/**
 * @generated SignedSource<<8e9bbfe438053479ba74909099e1aedb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportSurveysTableRowFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WebFormQuestionResponseTableFieldFragment" | "WebFormQuestionTableFieldFragment" | "WebFormQuestionTypeTableFieldFragment">;
  readonly " $fragmentType": "AdminMembersReportSurveysTableRowFragment";
};
export type AdminMembersReportSurveysTableRowFragment$key = {
  readonly " $data"?: AdminMembersReportSurveysTableRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportSurveysTableRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentUsageId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organizationMembershipId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminMembersReportSurveysTableRowFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WebFormQuestionTypeTableFieldFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WebFormQuestionTableFieldFragment"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "contentUsageId",
          "variableName": "contentUsageId"
        },
        {
          "kind": "Variable",
          "name": "organizationMembershipId",
          "variableName": "organizationMembershipId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "WebFormQuestionResponseTableFieldFragment"
    }
  ],
  "type": "WebFormQuestion",
  "abstractKey": null
};

(node as any).hash = "5d0eb2af6aafca226ac350e203dd4eae";

export default node;
